/**
 *
 * http配置
 */

import axios from 'axios';
import config from '@/config';
import store from '../vuex/store';
import * as types from '../vuex/types';
import router from '../router/index';
import { getPlatFormCode, getToken } from '../libs/util';

// axios 配置
axios.defaults.timeout = 500000;
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.post['Authorization'] = getToken();
axios.defaults.headers.post['Platform'] = getPlatFormCode();
// VUE_APP_CURRENTMODE: 未定义为本地 serve，'dev' 为测试环境包，'prod' 为生产包
const runMode = process.env.VUE_APP_CURRENTMODE;
axios.defaults.baseURL = !runMode
  ? config.baseUrl.local
  : runMode === 'dev' ? config.baseUrl.dev : config.baseUrl.pro;

// 判断访问路径是否为 https协议
let ishttps = 'https:' == document.location.protocol ? true : false
if(ishttps && axios.defaults.baseURL.startsWith('http:')) {
  // 更改请求为 https
  axios.defaults.baseURL = axios.defaults.baseURL.split(':')[0] + 's:' + axios.defaults.baseURL.split(':')[1]
} else {
  axios.defaults.baseURL = axios.defaults.baseURL
}

// http request 拦截器
axios.interceptors.request.use(
  config => {
    config.headers.Platform = getPlatFormCode();

    if (store.state.manageState > 0) {
      // console.log('使用店铺token')
      config.headers.Authorization = store.state.shopInfo[store.state.manageState].token;
    } else if (store.state.token) {
      // console.log('使用用户token')
      config.headers.Authorization = store.state.token;
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  });

// http response 拦截器
axios.interceptors.response.use(
  response => {
    if (response.data.code == 999999404) {
      store.commit('setOpenPopupModel', true);
    }
    return response;
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 401 清除token信息并跳转到登录页面
          store.commit(types.ClEARPlATFORM);
          store.commit(types.LOGOUT);
          router.replace({
            name: 'login',
            query: {
              redirect: router.currentRoute.fullPath
            }
          });
          break;
        case 403:
          // 403 清除token信息 并且去登陆
          store.commit(types.ClEARPlATFORM);
          store.commit(types.LOGOUT);
          // dialog.toast({mes: '需要登陆后才能操作！' ,timeout: 1500})
          router.replace({
            name: 'login',
            query: {
              redirect: router.currentRoute.fullPath
            }
          });
          break;
        case 406:
          store.commit(types.ClEARPlATFORM);
          router.replace({
            name: 'login',
            query: {
              redirect: router.currentRoute.fullPath
            }
          });
          break;
      }
    }
    return Promise.reject(error.response);
  });

export default {
  // fetchPost  请求方式
  fetchPost: function (url, params, query) {
    let urls = url;
    if (query) {
      urls = url + '?' + query;
    } else {
      urls = url;
    }
    return new Promise((resolve, reject) => {
      axios.post(urls, params)
        .then(response => {
          resolve(response.data);
        }, err => {
          reject(err);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // GET 请求方式
  fetchGet: function (url, params, header) {
    return new Promise((resolve, reject) => {
      axios.get(url, {
        params: params,
        responseType: header ? header.responseType : 'json'
      })
        .then(response => {
          resolve(response.data);
        }, err => {
          reject(err);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};
